<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <div class="flex flex-wrap field-value flex-direction-column">
      <NuxtLink
        v-for="department of formattedDepartments"
        :key="department.id"
        data-test="link"
        :to="`/departments/${encodeURIComponent(department.id)}/overview`"
        class="mb-1 color-theme-light hover:color-theme-base underline transition-all duration-300 ease-in-out"
      >
        {{ department.displayName || department.name }}
      </NuxtLink>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    question: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('departments', { departments: (state) => state.all }),
    formattedDepartments() {
      return this.value.map(
        (dep) =>
          typeof dep === 'object'
            ? dep
            : this.departments.find((el) => el.id === dep) || {
                id: dep,
                displayName: dep,
              }
      )
    },
  },
}
</script>
<style scoped>
.flex-direction-column {
  flex-direction: column;
}
</style>
